import useTokens from './use-tokens';
import { CanceledError, InternalAxiosRequestConfig } from 'axios';

declare module 'axios' {
  export interface AxiosRequestConfig {
    noAuth?: boolean;
  }
}

/**
 * Request Interceptor adding authorization header to requests
 */
export const requestInterceptor = async (request: InternalAxiosRequestConfig) => {
  const tokensStore = useTokens();

  if (!request.noAuth) {
    const tokens = await tokensStore.getValidTokens();

    if (!tokens) {
      // Without a valid token the request would fail anyway, so cancel it before
      // it's sent. Throwing from a request interceptor stops axios from dispatching
      // the request and rejects with this error. Using CanceledError means callers
      // can detect it via axios.isCancel(error).
      throw new CanceledError('Request canceled: no valid authentication token available.');
    }

    request.headers.Authorization = `Bearer ${tokens.accessToken}`;
  }

  return request;
};
